export default "__VITE_PUBLIC_ASSET__d81eeba7__"